module.exports = __webpack_public_path__ + "img/accredited-business.0c889b5f.svg";